import React from 'react';
import { createRoot } from 'react-dom/client';
import './toast.css';

/**
 * Toast seçenekleri. UYDURULMADI: `variant` değerleri tüm `showToast(...)`
 * çağrıları greplenerek çıkarıldı (error · info · success · warning);
 * `duration` gövdenin okuduğu tek diğer alan (bugün hiçbir çağrı geçmiyor,
 * ama gövde `item.duration`ı okuduğu için sözleşmede kalır).
 */
export type ToastSecenekleri = {
  variant?: "error" | "info" | "success" | "warning";
  duration?: number;
};

type ToastOgesi = ToastSecenekleri & { id: number; message: React.ReactNode };

let container: HTMLDivElement | null = null;
let root: ReturnType<typeof createRoot> | null = null;
let idCounter = 0;
let pushFn: ((item: ToastOgesi) => void) | null = null;

function ToastHost() {
  const [items, setItems] = React.useState<ToastOgesi[]>([]);

  React.useEffect(() => {
    pushFn = (item: ToastOgesi) => {
      setItems((prev) => [...prev, item]);
      const ttl = Math.max(1200, Math.min(item.duration || 2000, 6000));
      setTimeout(() => {
        setItems((prev) => prev.filter((t) => t.id !== item.id));
      }, ttl);
    };
    return () => { pushFn = null; };
  }, []);

  return (
    <div className="toast-container" role="status" aria-live="polite" aria-atomic="true">
      {items.map((t) => (
        <div key={t.id} className={`toast ${t.variant || ''}`} data-state="open">
          {t.message}
        </div>
      ))}
    </div>
  );
}

function ensureHost() {
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-root';
    document.body.appendChild(container);
    root = createRoot(container);
    root.render(<ToastHost />);
  }
}

export function showToast(message: React.ReactNode, opts: ToastSecenekleri = {}) {
  if (!message) return;
  ensureHost();
  const item = { id: ++idCounter, message, ...opts };
  if (pushFn) pushFn(item);
}
